import React from "react";

interface PreDynamicStateProps {
  height: number;
  id?: string;
}
export default function PreDynamicState(props: PreDynamicStateProps) {
  const { height, id } = props;
  return <div id={id} style={{ height: height }}></div>;
}

PreDynamicState.displayName = "PreDynamicState";
